type Props = {
  title: string;
};

const SectionTitle = ({ title }: Props) => {
  return (
    <h2 className="text-[2rem] font-semibold">{title}</h2>
  );
};

export default SectionTitle;
